/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSendInvitationRequestFromJSON(json) {
    return StreemApiSendInvitationRequestFromJSONTyped(json, false);
}
export function StreemApiSendInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fromUserSid': !exists(json, 'from_user_sid') ? undefined : json['from_user_sid'],
        'toUserName': !exists(json, 'to_user_name') ? undefined : json['to_user_name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
        'deliveryType': !exists(json, 'delivery_type') ? undefined : json['delivery_type'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
    };
}
export function StreemApiSendInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'from_user_sid': value.fromUserSid,
        'to_user_name': value.toUserName,
        'phone': value.phone,
        'reference_id': value.referenceId,
        'company_code': value.companyCode,
        'delivery_type': value.deliveryType,
        'integration_id': value.integrationId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiSendInvitationRequestDeliveryType;
(function (StreemApiSendInvitationRequestDeliveryType) {
    StreemApiSendInvitationRequestDeliveryType["EMAIL"] = "DELIVERY_TYPE_EMAIL";
    StreemApiSendInvitationRequestDeliveryType["INVALID"] = "DELIVERY_TYPE_INVALID";
    StreemApiSendInvitationRequestDeliveryType["LINK"] = "DELIVERY_TYPE_LINK";
    StreemApiSendInvitationRequestDeliveryType["SMS"] = "DELIVERY_TYPE_SMS";
})(StreemApiSendInvitationRequestDeliveryType || (StreemApiSendInvitationRequestDeliveryType = {}));
//# sourceMappingURL=StreemApiSendInvitationRequest.js.map